<template>
  <div>
    <vs-input
      v-validate="'required|email|min:3'"
      data-vv-validate-on="blur"
      name="email"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      label-placeholder="Email"
      v-model="email"
      v-on:keyup.enter="loginJWT()"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
      data-vv-validate-on="blur"
      v-validate="'required|min:6|max:15'"
      type="password"
      name="password"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather"
      label-placeholder="Password"
      v-model="password"
      v-on:keyup.enter="loginJWT()"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
    <div>
       <vue-recaptcha class="mt-5"
                    ref="recaptcha"
                    :sitekey="sitekey" 
                    @expired="onExpired" 
                    @verify="onVerify"
                    :loadRecaptchaScript="true"
                   ></vue-recaptcha>

    </div>
    <div class="flex flex-wrap justify-center items-center my-5">
      <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
        >Remember Me</vs-checkbox
      >
    </div>
    <div class="flex flex-wrap items-center justify-center mb-3">
      <vs-button :disabled="!validateForm" @click="loginJWT()">Sign In</vs-button>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import auth from '@/http/requests/auth/jwt/index.js';
export default {
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      recaptcha: '',
      sitekey: '6LecEakbAAAAAOL4tGqFxYTQUxvNCirlrkypNzm8',
      activeRecaptcha:process.env.VUE_APP_ACTIVE_RECAPTCHA
    }
  },
  components: {
    'vue-recaptcha': VueRecaptcha,
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== '' && this.password !== '' && (this.activeRecaptcha === 'true' ? this.recaptcha !== '' : true)
    },
  },
  mounted(){
    //this.detect()
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        // this.$vs.notify({
        //   title: 'Login Attempt',
        //   text: 'You are already logged in!',
        //   iconPack: 'feather',
        //   icon: 'icon-alert-circle',
        //   color: 'warning'
        // })

        return false
      }
      return true
    },
    loginJWT() {
      if (!this.checkLogin()) {
        this.$router.push('/')
        return
      }

      if(this.activeRecaptcha === 'true' && this.recaptcha === ''){
        return
      }

      this.$vs.loading()
          const payload = {
            checkbox_remember_me: this.checkbox_remember_me,
            userDetails: {
              recaptcha: this.recaptcha,
              email: this.email,
              password: this.password,
            },
          }
          this.$store
            .dispatch('auth/loginJWT', payload)
            .then( res => {
              this.$vs.loading.close()
              this.$router.push('/')
            })
            .catch(res => {
              this.showValidationErrors(res)
              this.$vs.loading.close()
            })
    },
    registerUser() {
      if (!this.checkLogin()) return
      this.$router.push('/pages/register').catch(() => {})
    },
    onVerify: function (response) {
      this.recaptcha = response
    },
    onExpired: function () {
      this.$vs.notify({
            color: 'danger',
            title: 'Atención',
            text: 'El captcha a expirado.',
          })
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset()
    },
    detect(){
      auth.detect()
      .then( res => console.log(res.data))
      .catch( err => console.log(err) )
    }   
  },
}
</script>
